import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as modalActions from '../../actions/common/modalActions';
import SweetAlert from 'react-bootstrap-sweetalert'


class SweetAlertModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            show,
            title,
            text,
            showConfirm,
        } = this.props.sweetAlertModal;
        return (
            <div>
                <SweetAlert
                show={show}
                title={title}
                customClass={'sweet-alert'}
                onConfirm={this.props.actions.hideSweetAlertModal}
                confirmBtnCssClass="clickable"
                showConfirm={showConfirm}>
                {text}
                </SweetAlert>
            </div>
        );
    }

}

function mapStateToProps(state, ownProps) {
    return {
        sweetAlertModal: state.sweetAlertModal,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(
            {},
            modalActions,
        ), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SweetAlertModal);


// WEBPACK FOOTER //
// ./web/src/components/common/SweetAlertModal.jsx